<template>
   <fragment>
      <label v-show="shown" :for="name" :class="classLabel">{{label}}</label>
      <div v-show="shown" :class="'col-sm-' + icols">
         <input
            :type="inputType"
            class="form-control"
            :id="name"
            :placeholder="'(' + label.toLowerCase() + ')'"
            @blur="touch"
            :class="{ 'error--input': isError }"
            :value="value"
            @input="handleChange"
            @change="handleChange"
            :readonly="isReadonly"
            v-show="shown"
         />
         <div v-show="shown" class="error--msg" v-if="isError">
            <!-- {{ $parent.$parent.errorText(v$) }} -->
            {{ errorText(v$) }}
         </div>
      </div>
   </fragment>
</template>


<script>
import { Fragment } from 'vue-fragment'
import moment from "moment";

export default {
   name: "fieldcol",
   components: { 'fragment': Fragment },
   props: ['name','label','value','v$','lcols','icols','typ','show', 'validator', 'readonly', 'labelClassOverride' ],
   data() {
      return {
         inputType: 'text'
      };
   },
   computed: {
      classLabel: function () {
         let obj = {
            'col-form-label': true,
            'error--label': this.isError
         }

         if(this.labelClassOverride && this.labelClassOverride != ''){
            obj[this.labelClassOverride] = true
         }
         else{
            obj['col-sm-' + this.lcols] = true
         }

         return obj
      },
      isError: function() {
         if (this.v$ === undefined) return false
         return this.v$.$error
      },
      shown: function() {
         var result = true
         if (this.show != null && this.show != undefined) {
            result = this.show
         } 
         return result
      },
      isReadonly: function(){
         if(this.$parent != undefined 
         && this.$parent.$parent != undefined 
         && typeof this.$parent.$parent.readOnly === 'function')
         {
            return this.$parent.$parent.readOnly()
         }
         else
         {
            return this.readOnly
         }
      },
      
   },
   mounted() {
      if (this.typ && this.typ!='')
         this.inputType = this.typ
   },
   methods: {
      handleChange: function (event) {
         this.$emit('input', event.target.value)
         this.$emit('change')
      },
      touch: function(event) {
         if (event.target.id == 'personal.ssn' || 
             event.target.id == 'personal.businessTaxID' ||
             event.target.id == 'personal.cellNumber' ||
             event.target.id == 'personal.businessCellNumber' ||        
             event.target.id == 'personal.businessFaxNumber2' ||        
             event.target.id == 'personal.businessFaxNumber'  ||
             event.target.id == 'commissionRemitAssign.ssnTaxID' ||
             event.target.id == 'apptIRSInfo.employerIdNumber'  
         ) {
            let newVlu = this.$parent.$parent.cleanNumber(event.target.value)
            if (event.target.value != newVlu) {
               event.target.value = newVlu
               this.handleChange(event)
            }
         }
         
         if (this.v$ === undefined) return
         this.v$.$touch()
      },
      errorText: function(err){
         if (err && err.$error) {
            return err.$errors.map(itm => itm.$message).join(',')
         } 
         return ''
      }
   },
};
</script>

<style scoped lang="scss">
@import "../assets/css/colors.scss";
@import "../assets/css/application.scss";
@import "../assets/css/validation.scss";

.col-form-label { 
   font-size: smaller;
   text-align: right;
   padding-right: 0;
}

/* Any Custom CSS classes you wish to pass into this component as :labelClassOverride, should be added here */
.label-auto-width {
  display: inline-block;   /* Fits the width of the content */
  white-space: nowrap;     /* Prevents word wrapping */
  text-align: left;        /* Aligns text to the left */
  padding-right: 10px;     /* Optional padding for spacing */
  vertical-align: middle;  /* Aligns the label vertically with input fields */
}
</style>